import { render } from "./LbrxKeyboard.vue?vue&type=template&id=b6488072&scoped=true"
import script from "./LbrxKeyboard.vue?vue&type=script&lang=js"
export * from "./LbrxKeyboard.vue?vue&type=script&lang=js"

import "./LbrxKeyboard.vue?vue&type=style&index=0&id=b6488072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6488072"]])

export default __exports__